<template>
    <div class="login-wrapper-page">

        <div v-if="widgetReady" class="panel login-panel">
            <div class="login-panel-heading">
                <div class="login-logo"></div>
            </div>

            <div class="login-panel-body">
                <h5 class="text-muted text-center">{{ welcomeVerbiage }}</h5>
                <form class="form-horizontal" style="margin: 20px;">
                    <div class="row form-group text-center">
                        <div class="col-xs-12">
                            <input id="username" placeholder="Email or Username" type="text" v-model="userName" style="margin: 0 0 20px 0;">
                            <input id="password" placeholder="Password" type="password" v-model="password" style="margin: 20px 0;">
                        </div>
                        <div class="col-xs-12">
                            <ac-button id="login-button" class="btn-sm btn-login btn-lgncolor" :action="login" style="margin: 0 0 20px 0; width:100%">SIGN IN</ac-button>
                        </div>
                        <div class="col-xs-12">
                            <ul style="list-style-type: none">
                                <li>
                                    <router-link to="/passwordReset">
                                        <i class="fa fa-lock"></i> Forgot your password?
                                    </router-link>
                                </li>
                                <li style="padding: 10px 0;">
                                    <router-link to="/userVerification">
                                        Member Account Verification
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xs-12">
                            <h5 v-if="footerVerbiage" class="text-center text-muted">{{ footerVerbiage }}</h5>
                            <h5 v-else class="text-center text-muted">
                                <strong>Office Administrators:</strong>
                                <span class="text-center">To verify a member's enrollment eligibility and services included
                                    in his/her membership, please click <a v-bind:href="verificationUrl">here.</a>
                                </span>
                            </h5>
                            <hr/>
                        </div>
                        <div class="col-xs-7">
                            <small>
                                By signing into Accresa Health you hereby agree to both the 
                                <a href="https://www.myameriflex.net/Document/Viewer/c0a7bf1aa9894d7e98dd4b80b6393f67" target="_blank">
                                    Terms and Conditions
                                </a>
                                and 
                                <a href="https://www.myameriflex.net/Document/Viewer/b0fa2e6c69d14b70aa297454326302ce" target="_blank">
                                    Privacy Statement.
                                </a>
                            </small>
                        </div>
                        <div class="col-xs-5">
                            <img src="../../../assets/images/hipaa-150.png">
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import {common} from "../../../global/common.js";
    import {customStyleLoader} from "../../../global/customStyleLoader.js";

    export default {
        name: "login",
        data: function () {
            return {
                widgetReady: false,
                userName: '',
                password: '',
                verificationUrl: `${window.location.protocol}//${window.location.hostname}/general/#/verificationCenter`,
                welcomeVerbiage: null,
                footerVerbiage: null,
                supportEmail: null,
            }
        },
        async mounted() {
            let result = await customStyleLoader.loadCustomStyleFromUrl(this.$route);

            if (result) {
                this.welcomeVerbiage = result.welcomeVerbiage || "Please sign in to access your account";
                this.footerVerbiage = result.footerVerbiage;
                this.supportEmail = result.supportEmail;
            }
            this.widgetReady = true;
        },
        methods: {
            async login() {
                let redirectUrl = this.$route.query.urlRedirect || null;
                common.logUserIn(this.userName, this.password, redirectUrl, true);
            }
        }
    }
</script>
<style>

</style>
